import { IncentiveCategory } from '@varo/graphql-schema-types';

const INCENTIVE_COPY_NAMESPACES: Record<IncentiveCategory, string> = {
  [IncentiveCategory.Sweepstakes]: 'sweepstakes',
};

export const getIncentiveCopyPrefix = (
  incentiveType: IncentiveCategory,
  section: string,
) => `${INCENTIVE_COPY_NAMESPACES[incentiveType]}.${section}`;
